module.exports = {"id":"205401","name":"Valeri Qazaishvili","rating":"76","photo":"./data/images/photos/0/205401.png","club":{"name":"SJ Earthquakes","logo":"./data/images/clubs/SJEarthquakes.png"},"positions":["MOC","MG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ValeriQazaishvili0.json
// module id = 4226
// module chunks = 0